import Vue from "vue";
import * as Sentry from "@sentry/vue";
import router from "../router";

export function initSentry() {
  if (!process.env.VUE_APP_SENTRY_DSN) {
    return;
  }

  Sentry.init({
    Vue,
    dsn: process.env.VUE_APP_SENTRY_DSN,
    environment: process.env.NODE_ENV,
    release: process.env.VUE_APP_VERSION || "1.0.0",
    // Keine IP-Adressen, Cookies oder Nutzerdaten an Sentry (siehe Datenschutzerklärung)
    sendDefaultPii: false,

    integrations: [Sentry.browserTracingIntegration({ router })],

    tracesSampleRate: process.env.NODE_ENV === "production" ? 0.2 : 1.0,

    // Props und Komponentennamen in Fehlerberichten
    trackComponents: true,

    // Vue-Fehler auch in der Console ausgeben (hilfreich außerhalb Production)
    logErrors: process.env.NODE_ENV !== "production"
  });

  interceptConsole();
}

function interceptConsole() {
  const originalConsoleError = console.error;
  const originalConsoleWarn = console.warn;

  console.error = function(...args) {
    originalConsoleError.apply(console, args);
    try {
      const message = args
        .map(a =>
          a instanceof Error
            ? a.message
            : typeof a === "object"
            ? JSON.stringify(a)
            : String(a)
        )
        .join(" ");
      Sentry.captureMessage(message, "error");
    } catch (_) {
      /* ignore */
    }
  };

  console.warn = function(...args) {
    originalConsoleWarn.apply(console, args);
    try {
      const message = args
        .map(a =>
          a instanceof Error
            ? a.message
            : typeof a === "object"
            ? JSON.stringify(a)
            : String(a)
        )
        .join(" ");
      Sentry.captureMessage(message, "warning");
    } catch (_) {
      /* ignore */
    }
  };
}
